export const sparkleStyles = {
    '@keyframes sparkle': {
      '0%': { 
        color: '#4dabf5', // Blue
        transform: 'rotate(0deg) scale(1)'
      },
      '20%': { 
        color: '#7c4dff', // Purple
        transform: 'rotate(72deg) scale(1.2)'
      },
      '40%': { 
        color: '#ff4081', // Pink
        transform: 'rotate(144deg) scale(1)'
      },
      '60%': { 
        color: '#00e676', // Green
        transform: 'rotate(216deg) scale(1.2)'
      },
      '80%': { 
        color: '#ffeb3b', // Yellow
        transform: 'rotate(288deg) scale(1)'
      },
      '100%': { 
        color: '#4dabf5', // Back to Blue
        transform: 'rotate(360deg) scale(1)'
      }
    },
    animation: 'sparkle 4s infinite ease-in-out',
    transformOrigin: 'center',
    display: 'inline-block',
    filter: 'brightness(1.2)',  // Makes colors slightly brighter
    transition: 'all 0.3s ease'
  };
